export default {"src":"/_next/static/media/0x4b9eb6c0b6ea15176bbf62841c6b2a8a398cb656.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};